import { zones } from './json/countries.json';

function getCountryByTimeZone(timeZone: string) {
  const timezone_object = zones[timeZone as keyof typeof zones];

  if (
    !timezone_object ||
    !timezone_object.countries ||
    !timezone_object.countries.length
  ) {
    return 'UNK';
  }

  return timezone_object.countries[0] || 'UNK';
}

export function getBrowserInfo() {
  const language = navigator.language;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  let country = '';

  country = getCountryByTimeZone(timezone);

  return { language, timezone, country };
}

declare global {
  interface Window {
    Android?: any;
    webkit?: any;
    isNativeApp?: boolean;
  }
}

export function isRunningInPWA() {
  if (
    typeof window.Android !== 'undefined' ||
    typeof window.webkit !== 'undefined'
  ) {
    return true;
  }

  const ua = navigator.userAgent || '';

  if (ua.includes('wv') || ua.includes('WebView')) {
    return true;
  }

  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }

  return (window as any).isNativeApp === true;
}

export function isRunningInTWA() {
  return (
    document.referrer.includes('app_source=app&standalone=true') ||
    document.referrer.startsWith('android-app://')
  );
}
